import React from "react";
import { useSiteState } from "../../utils/useSiteState";
import { createDocsUrl } from "../../utils/urls";

const Box = ({
  title,
  value,
}: {
  title: string;
  value: string | JSX.Element;
}) => {
  return (
    <div className="bg-gray-500 w-full p-4 mb-4 rounded-xl shadow-ld bg-opacity-25">
      <h6 className="text-xs text-gray-450">{title}</h6>
      <p className="text-white text-sm font-medium">{value}</p>
    </div>
  );
};

const ProjectDashboardInfo = () => {
  const { site } = useSiteState();

  if (!site) return null;

  return (
    <div className="bg-gray-600 bg-opacity-50 h-7/12 w-full rounded-xl p-8 flex justify-start items-start flex-col overflow-auto p-10 flex-shrink-0">
      {/* {JSON.stringify(site)} */}
      <h5 className="text-white font-medium text-lg mb-6">
        Project Information
      </h5>
      <Box title="Site Title" value={site.title} />
      <Box
        title="Site URL"
        value={
          <a
            target="_blank"
            href={`https://${createDocsUrl(site)}`}
            rel="noopener noreferrer"
          >
            {createDocsUrl(site)}
          </a>
        }
      />
      <Box title="Status" value={site.published ? "Published" : "Draft"} />
      <Box
        title="App Status"
        value={site.is_coming_soon ? "Coming Soon" : "Live"}
      />
    </div>
  );
};
export default ProjectDashboardInfo;
